import { render, staticRenderFns } from "./BookSimple.vue?vue&type=template&id=712a5d5b&scoped=true&"
import script from "./BookSimple.vue?vue&type=script&lang=js&"
export * from "./BookSimple.vue?vue&type=script&lang=js&"
import style0 from "./BookSimple.vue?vue&type=style&index=0&id=712a5d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a5d5b",
  null
  
)

export default component.exports